import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';
import logoDark from "../../assets/images/logo-sin-texto.png"
import logoLight from "../../assets/images/logo-sin-texto.png"

import {FiFacebook,FiInstagram, FiLinkedin} from "../../assets/icons/vander"


export default function PersonalNavbar(){
    const [scroll, setScroll] = useState(false);
    const [isMenu, setisMenu] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
          setScroll(window.scrollY > 50);
        });
      }, []);

      const toggleMenu = () => {
        setisMenu(!isMenu);
        if (document.getElementById("navigation")) {
            const anchorArray = Array.from(document.getElementById("navigation").getElementsByTagName("a"));
            anchorArray.forEach(element => {
                element.addEventListener('click', (elem) => {
                    const target = elem.target.getAttribute("href")
                    if (target !== "") {
                        if (elem.target.nextElementSibling) {
                            var submenu = elem.target.nextElementSibling.nextElementSibling;
                            submenu.classList.toggle('open');
                        }
                    }
                })
            });
        }
    };
    return(
        <header id="topnav" className="nav-sticky defaultscroll sticky">
            <div className="container">
				<Link1 className="logo" to="home">
                    <img src={logoDark} className="logo-light-mode" alt="" style={{width:'70px'}} />
                    <img src={logoLight} className="logo-dark-mode" alt="" style={{width:'70px'}}/>
                </Link1>
                <div className="menu-extras">
                    <div className="menu-item">
                        <Link to="#" className={`navbar-toggle ${isMenu ? 'open' : ''}`} id="isToggle" onClick={() => toggleMenu()}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    </div>
                </div>
                <ul className="buy-button list-inline mb-0">
                    <li className="list-inline-item ms-1"><Link to="" className="btn btn-sm btn-icon btn-pills btn-primary"><FiInstagram className="icons"/></Link></li>
                </ul>
        
                <div id="navigation" style={{ display: isMenu ? 'block' : 'none' }}>  
                    <ul className="navigation-menu nav-right personal-menu" id="navmenu-nav">
                        <li className="has-submenu">
                            <Link1 to="home" activeClass="active"  spy={true} smooth={true} duration={500} className="sub-menu-item" onClick={() => toggleMenu()}>Home</Link1>
                        </li>

                        <li className="has-submenu parent-parent-menu-item">
                            <Link to="#">Pilates Máquina</Link><span className="menu-arrow"></span>
                            <ul className="submenu">
                                <li><Link1 to="pilatesMaquinaGrupal" className="sub-menu-item" onClick={() => toggleMenu()}>Grupal</Link1></li>
                                <li><Link1 to="pilatesMaquinaIndividual" className="sub-menu-item" onClick={() => toggleMenu()}>Individual</Link1></li>
                                <li><Link1 to="pilatesPrenatalYPostparto" className="sub-menu-item" onClick={() => toggleMenu()}>Prenatal</Link1></li>
                            </ul>
                        </li>

                        <li className="has-submenu">
                            <Link1 to="tarifasYHorarios" activeClass="active"  spy={true} smooth={true} duration={500} className="sub-menu-item" onClick={() => toggleMenu()}>
                            Tarifas y horarios
                            </Link1>
                        </li>

                        <li className="has-submenu">
                            <Link1 to="dondeEstamos" activeClass="active"  spy={true} smooth={true} duration={500} className="sub-menu-item" onClick={() => toggleMenu()}>
                            Donde estamos
                            </Link1>
                        </li>

                        <li className="has-submenu">
                            <Link1 to="nosotrosTeLlamamos" activeClass="active"  spy={true} smooth={true} duration={500} className="sub-menu-item text-primary" onClick={() => toggleMenu()}>
                            1ª clase gratuita
                            </Link1>
                        </li>

                        <li className="has-submenu">
                            <Link1 to="trabajaConNosotros" activeClass="active"  spy={true} smooth={true} duration={500} className="sub-menu-item text-primary" onClick={() => toggleMenu()}>
                            Trabaja con nosotros
                            </Link1>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    )
}